import React from 'react';
export function PainPoints() {
  const points = ['Buscaste en YouTube. Encontraste videos a medias.', 'Intentaste aprender solo. Te perdiste en la teoría.', 'Quisiste arrancar. No sabías por dónde.'];
  return <section className="bg-brand-surface text-brand-text px-4 py-10" data-id="element-80">
      <div className="max-w-xl mx-auto" data-id="element-81">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-yellow" data-id="element-82">
          La verdad que nadie te dice.
        </h2>

        <div className="space-y-3 mb-6" data-id="element-83">
          {points.map((point, i) => <p key={i} className="text-sm md:text-base text-brand-text bg-brand-card border border-brand-border rounded-lg p-3" data-id="element-84">
              {point}
            </p>)}
        </div>

        <p className="text-sm md:text-base text-brand-muted mb-3 leading-relaxed text-center" data-id="element-85">
          Y mientras tanto seguís pagándole a otros por trabajos que vos mismo
          podrías hacer. Seguís dejando pasar oportunidades de trabajo porque te
          falta seguridad técnica. Seguís sin tener una guía clara que te lleve
          de cero a resultados reales.
        </p>

        <p className="text-base md:text-lg font-black text-center text-yellow" data-id="element-86">
          Eso tiene solución. Y está acá.
        </p>
      </div>
    </section>;
}